// CASE ASSIGNMENT HOOKS — Phase L
import { useState, useEffect, useCallback } from 'react';
import { caseAssignmentService } from '../../api/services/caseAssignmentService';
import type { ID } from '../../api/types';
import type { CaseAssignment, CaseRole } from '../../api/types/caseAssignment.types';

export const useCaseRoles = () => {
  const [data, setData] = useState<CaseRole[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetch = useCallback(async () => {
    setLoading(true); setError(null);
    try { setData(await caseAssignmentService.getRoles()); }
    catch (err) { setError(err as Error); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetch(); }, [fetch]);
  return { data, loading, error, refetch: fetch };
};

export const useCaseAssignments = (caseId: ID | undefined, openOnly = false, refreshKey?: number) => {
  const [data, setData] = useState<CaseAssignment[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetch = useCallback(async () => {
    if (!caseId) { setData([]); return; }
    setLoading(true); setError(null);
    try { setData(await caseAssignmentService.getByCase(caseId, openOnly)); }
    catch (err) { setError(err as Error); }
    finally { setLoading(false); }
  }, [caseId, openOnly]);

  useEffect(() => { fetch(); }, [fetch, refreshKey]);
  return { data, loading, error, refetch: fetch };
};
